import React from 'react';
import { useHistory } from 'react-router-dom';
import SignupForm from './components/SignupForm';
import { useAuth } from '../../contexts/AuthContext';

const SignupPage = () => {
  const {
    signup,
    loading,
    error,
  } = useAuth();
  const history = useHistory();

  const onSubmitSignupForm = async (fullName, email, password) => {
    const result = await signup(email, password, fullName);

    if (result.success) {
      if (result.requiresConfirmation) {
        // Redirect to confirmation page with username and email
        history.push('/confirm-email', {
          username: result.username,
          email,
        });
      } else {
        // Direct login success
        history.push('/');
      }
    }
  };

  return (
    <div className="account">
      <div className="account__wrapper">
        <div className="account__card">
          <div className="account__head">
            <h3 className="account__title">Welcome to
              <span className="account__logo"> Revenue
                <span className="account__logo-accent">OS</span>
              </span>
            </h3>
            <h4 className="account__subhead subhead">Accelerate your revenue growth</h4>
          </div>
          <SignupForm onSubmit={onSubmitSignupForm} loading={loading} error={error} />
        </div>
      </div>
    </div>
  );
};

export default SignupPage;

// if you want to add select, date-picker and time-picker in your app you need to uncomment the first
// four lines in /scss/component/form.scss to add styles
